var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { gql, useQuery } from '@apollo/client';
import { OnboardingStep } from '../../../types/GloblalTypes';
import { useIsDynamicBooleanEnabled } from '../../DynamicValues/hook';
import { DYNAMIC_VALUES_NAME } from '../../DynamicValues';
export var GET_COMPLETED_ONBOARDING_STEPS_QUERY = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query getCompletedTeamAccountOnboardingSteps($teamAccountId: String!) {\n    getCompletedTeamAccountOnboardingSteps(teamAccountId: $teamAccountId) {\n      steps\n    }\n  }\n"], ["\n  query getCompletedTeamAccountOnboardingSteps($teamAccountId: String!) {\n    getCompletedTeamAccountOnboardingSteps(teamAccountId: $teamAccountId) {\n      steps\n    }\n  }\n"])));
export var useGetCompletedTeamAccountOnboardingStepsQuery = function (teamAccountId, options) {
    if (options === void 0) { options = {}; }
    var isSelfServeOnboardingEnabled = useIsDynamicBooleanEnabled(DYNAMIC_VALUES_NAME.ddfwSelfServeOnboarding);
    var result = useQuery(GET_COMPLETED_ONBOARDING_STEPS_QUERY, __assign({ variables: {
            teamAccountId: teamAccountId,
        }, skip: !teamAccountId || !isSelfServeOnboardingEnabled }, options));
    return result;
};
export var useIsOnboardingFinished = function (teamAccountId) {
    var _a, _b;
    var _c = useGetCompletedTeamAccountOnboardingStepsQuery(teamAccountId), data = _c.data, loading = _c.loading;
    var completedSteps = (_b = (_a = data === null || data === void 0 ? void 0 : data.getCompletedTeamAccountOnboardingSteps) === null || _a === void 0 ? void 0 : _a.steps) !== null && _b !== void 0 ? _b : [];
    var isOnboardingFinished = !loading &&
        completedSteps.includes(OnboardingStep.ONBOARDING_STEP_FINISH_ONBOARDING);
    return { isOnboardingFinished: isOnboardingFinished, loading: loading, completedSteps: completedSteps };
};
var templateObject_1;
